import { put, call, select, delay, race } from 'redux-saga/effects'
import { createModal } from 'redux-saga-modal'
import {
  FETCH_LIST,
  SHOW_INFO_DIALOG,
  SHOW_COUPON_STATS_DIALOG
} from './actionTypes'
// import { getSessionList } from './selectors'
import * as services from './services'
import * as actions from './actions'
import { message } from 'antd'

export default {
  *[FETCH_LIST]({ payload }) {
    const { params } = payload
    yield actions.toggleLoading()
    const { data, total } = yield call(services.fetchTenantCoupons,params)
    yield put(actions.tenantCouponsFetched({ data, total }))
    yield actions.toggleLoading()
  },

  *[SHOW_INFO_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('COUPON_DIALOG')

    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },

  *[SHOW_COUPON_STATS_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('COUPON_STATS_DIALOG')

    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
}